/**
* Convert czk to given currency
*
* @param {number} czk - Amount of czk
* @param {number} rate - Conversion rate
* @param {string} curr - Currency
* @returns {number} converted price
*/
export const czk_to_eur = (czk: number, rate: number, curr: string) => {
    if (curr === "eur") {
        return czk/rate  
    }
    return czk
}
/**
* Convert euros to czk
*
* @param {number} eur - Amount of eur
* @param {number} rate - Conversion rate
* @returns {number} czk
*/
export const eur_to_czk = (eur: number, rate: number) => {
    return eur*rate
}


export const formatPrice = (value: number | string): string => {
    const num = typeof value === "string" ? Number(value) : value;

    if (Number.isNaN(num)) return "";
    const formatted = num
        .toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        })
        .replace(/,/g, " ");

    return `${formatted}`;
};

export const getCurrencyLabel = (currency: string) => (currency === "eur" ? "EUR" : "K\u010d");

export const formatCurrency = (value: number | string, currency: string): string => {
    const formatted = formatPrice(value);
    if (!formatted) return "";
    return `${formatted} ${getCurrencyLabel(currency)}`;
};

export const toCurrencyAmount = (czk: number, rate: number, currency: string): number => {
    return Number(czk_to_eur(czk, rate, currency).toFixed(2));
};

export const formatCurrencyFromCzk = (czk: number, rate: number, currency: string): string => {
    const amount = toCurrencyAmount(czk, rate, currency);
    return formatCurrency(amount, currency);
};
